function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M512 0C230.4 0 0 230.4 0 512s230.4 512 512 512 512-230.4 512-512S793.6 0 512 0z m256 531.2c0 41.6-6.4 83.2-6.4 83.2s-6.4 35.2-19.2 51.2c-19.2 19.2-41.6 19.2-51.2 22.4-70.4 6.4-179.2 6.4-179.2 6.4s-134.4 0-172.8-6.4c-12.8-3.2-38.4 0-57.6-22.4-16-16-19.2-51.2-19.2-51.2S256 572.8 256 531.2v-38.4c0-41.6 6.4-83.2 6.4-83.2s6.4-35.2 19.2-51.2c19.2-19.2 41.6-19.2 51.2-22.4 70.4-6.4 179.2-6.4 179.2-6.4s108.8 0 179.2 6.4c9.6 0 32 0 51.2 22.4 16 16 19.2 51.2 19.2 51.2s6.4 41.6 6.4 83.2v38.4z",
  fill: "#3FD5D3",
  "p-id": 6220
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M457.6 579.2l140.8-73.6-140.8-70.4z",
  fill: "#3FD5D3",
  "p-id": 6221
});

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1632387963706,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 6219,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.07e09de1.svg";
export { ForwardRef as ReactComponent };